module.exports = __webpack_public_path__ + "img/souvenirs-thermos-02.ccd014ab.png";